import React, { useMemo } from "react";
import { notification, Space } from "antd";

const Context = React.createContext({ name: "Default" });

const openNotification = (
  type: "success" | "error" | "info" | "warning",
  message: string,
  description: string
) => {
  notification[type]({
    message,
    description,
    placement: "topRight",
  });
};

const Notification: React.FC = () => {
  const [api, contextHolder] = notification.useNotification();

  const contextValue = useMemo(() => ({ name: "Ant Design" }), []);

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      {/* <Space
        style={{ backgroundColor: "yellow", padding: "10px", display: "block" }}
      /> */}
      <Space style={{ padding: "10px", display: "block" }} />
    </Context.Provider>
  );
};

export default Notification;
export { openNotification };
